import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IQuestionSubType } from "../../../Pages/QuestionSubType/IQuestionSubType";

export const AddQuestionSubTypeSlice = createSlice({
  name: "AddQuestionSubTypeSlice",
  initialState: {} as IReduxState<IQuestionSubType>,  
  reducers: {
    addQuestionSubType: (state, _: PayloadAction<IQuestionSubType>) => {
      console.log(">>>> addQuestionSubType", state);
      
      state.isLoading = true;
    },
    successaddQuestionSubType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddQuestionSubType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddQuestionSubTypeResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addQuestionSubType,
  failureaddQuestionSubType,
  successaddQuestionSubType,
  clearAddQuestionSubTypeResponse,
} = AddQuestionSubTypeSlice.actions;

export default AddQuestionSubTypeSlice.reducer;
